import "./polyfills";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./i18n";
import "@akuna/ui/styles.css";
import "./index.css";
import { applyDomGuards } from "@/lib/dom-guards";
import { DOMErrorBoundary } from "@/components/DOMErrorBoundary";
import { initMonitoring } from "@/lib/monitoring";
import { initNativeApp } from "@/lib/native";

void initMonitoring();
void initNativeApp();

applyDomGuards();

createRoot(document.getElementById("root")!).render(
  <DOMErrorBoundary>
    <App />
  </DOMErrorBoundary>
);
